import React from 'react';
import { useTranslation } from 'react-i18next';

import { useWorkspace } from '@mssgme/hooks';
import { LinkButton, Scrollbar } from '@mssgme/ui';
import IntegrationsPage from '../Integrations/IntegrationsPage';

import styles from './OnboardPage.scss';

export default function OnboardPage() {
    const { t } = useTranslation('inbox');
    const workspace = useWorkspace();
    const hasIntegrations = workspace.integrations.length > 0;

    return (
        <Scrollbar>
            <div className={styles.root}>
                <IntegrationsPage>
                    <div className={styles.footer}>
                        <LinkButton disabled={!hasIntegrations} to="/i">
                            {t('OnboardPage.complete')}
                        </LinkButton>
                    </div>
                </IntegrationsPage>
            </div>
        </Scrollbar>
    );
}
